import useAuthStore from '@/app/store/auth.store';

export const useAuth = () => {
  const {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    refreshAuth,
  } = useAuthStore();

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    refreshAuth,
  };
};

export const useCurrentUser = () => {
  const user = useAuthStore((state) => state.user);
  return user;
};

export const useAuthToken = () => {
  const token = useAuthStore((state) => state.token);
  return token;
};

export default useAuth;